import React from 'react';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { updateFormField, getAllowanceFormValues } from 'src/reducers/clients/allowances';
import selector from 'src/utils/Utils';
import { getRadioOptions } from 'src/reducers/selectOptions';
import { RadioField } from 'src/jbc-front/components/Form';

import AllowancePaymentFixed from './AllowancePaymentFixed';
import AllowancePaymentFormula from './AllowancePaymentFormula';
import AllowancePaymentIndividual from './AllowancePaymentIndividual';
import AllowanceMotivation from '../Motivation/AllowanceMotivation';

// Feature flags - Keep consistent with AllowanceEditingForm
const FEATURE_FLAGS = {
  // @TODO: Enable motivation option when Diligence allowance feature is ready
  // https://donuts-vn.atlassian.net/browse/JBC-26
  SHOW_MOTIVATION_OPTION: false
};

const AllowancePayment = ({
  dispatch,
  selectedAllowanceAmountType,
  payrollRulesGroup,
  allowanceAmountTypes,
  formulaOrderType,
  selectedPaymentType,
  isYearEndAdjustment,
  isBaseSalaryOrCommuting
}) => {
  const { t } = useTranslation();
  const shouldRenderAllowanceTypeRadioField = !isYearEndAdjustment && selectedPaymentType === 'normal';
  const handleAllowanceSetting = (event, value) => {
    if (value === 'fixed' || value === 'individual') {
      dispatch(updateFormField('isAnnualTaxEstimation', true));
      dispatch(updateFormField('isSscCalculation', true));
    } else {
      dispatch(updateFormField('isAnnualTaxEstimation', false));
      dispatch(updateFormField('isSscCalculation', false));
    }
  };

  return (
    <>
      {shouldRenderAllowanceTypeRadioField && (
        <RadioField
          label={t('features.ClientAllowances.components.AllowanceEditingForm.Amount_Setting')}
          name="allowanceAmountType"
          required
          options={allowanceAmountTypes.slice(1)}
          disabled={isBaseSalaryOrCommuting || formulaOrderType === 'provident_fund'}
          onChange={handleAllowanceSetting}
        />
      )}

      {/* Conditionally render motivation component based on feature flag */}
      {FEATURE_FLAGS.SHOW_MOTIVATION_OPTION &&
        selectedPaymentType === 'motivation' && (
          <div>
            <AllowanceMotivation />
          </div>
        )}

      <div>
        {selectedAllowanceAmountType === 'fixed' && <AllowancePaymentFixed payrollRuleGroup={payrollRulesGroup} />}
        {selectedAllowanceAmountType === 'formula' && <AllowancePaymentFormula />}
        {selectedAllowanceAmountType === 'individual' && <AllowancePaymentIndividual payrollRulesGroup={payrollRulesGroup} />}
      </div>
    </>
  );
};

const mapStateToProps = state => ({
  selectedAllowanceAmountType: selector(getAllowanceFormValues(state), 'allowanceAmountType'),
  formulaOrderType: selector(getAllowanceFormValues(state), 'formulaOrderType'),
  allowanceAmountTypes: getRadioOptions(state, 'allowanceAmountTypes'),
  selectedPaymentType: selector(getAllowanceFormValues(state), 'paymentType')
});

export default connect(mapStateToProps)(AllowancePayment);
